
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, Button, FormGroup, Label,
    InputGroup, Input, InputGroupAddon
} from 'reactstrap';

//import { GoogleApiWrapper } from 'google-maps-react';

import { alertService } from 'components/Varios/alert_service.js';
import SelectItem from "components/Varios/select.js";
import ModalMap from "components/Varios/Map.js";    

import Icon from './Varios/Icons';
import { authenticationService } from '../services/authentication.service';
import { FilesUpload, SelectCombo } from './Types/GeneralTypes';
import InputFileUpload from './Varios/InputFileUpload';
import InputFileDownload from './Varios/InputFileDownload';
import axios from 'axios';
import { UserData } from './Sidebar/Sidebar_Principal';
import { authHeaderWithUserData } from 'helpers/auth-header';
import { mensajeCamposIncompletos } from './constants';

const API_URL = configData.SERVER_URL

var latL = -2.1729616;
var lngL = -79.9006161;
var latO = -2.1729616;
var lngO = -79.9006161;

const SELECT_LOCALIZACIONES: Array<SelectCombo> = [
    { label: "NORTE", value: "N" },
    { label: "SUR", value: "S" },
    { label: "ESTE", value: "E" },
    { label: "OESTE", value: "O" },
    { label: "NORESTE", value: "NE" },
    { label: "NOROESTE", value: "NO" },
    { label: "SURESTE", value: "SE" },
    { label: "SUROESTE", value: "SO" },
]

export class DireccionesData {
    idlugardomicilio: number = 0;
    idparroquia: number = 0;
    idcanton: number = 0;
    idprovincia: number = 0;
    idpais: number = 1;
    idpersona: number = 0;

    direccion: string = "";
    direccionalterna: string = "";
    cdlaobarrio: string = "";
    direcciontiponro?: string = "";
    bloquemanzana: string = "";
    referencia: string = "";
    coordenadas: string = "";
    codigopostal: string = "";

    Namearchivocroquis: string = "*****";
    estado: string = "A";
    version: number = 0;

    localizacion: string = "";
    refPlanilla: string | undefined = undefined;

    //Usado para almacenar temporalmente el documento, que se obtiene desde la entidad TBLOTROSDOCUMENTOS,
    namearchivoplanilla: string = ""
}

interface DireccionesDataState {
    currentUser: any;
    loading: boolean;
    dtoDataL: DireccionesData;
    dtoDataO: DireccionesData;
    paisListL: Array<any>;
    paisListO: Array<any>;
    provinciaListL: Array<any>;
    provinciaListO: Array<any>;
    cantonListL: Array<any>;
    cantonListO: Array<any>;
    parroquiaListL: Array<any>;
    parroquiaListO: Array<any>;
    error: null;
    errorOccurred: boolean;
    idNacionalidad: number;
    lugarResidenciaVisible: boolean;
    planillaServiciosBasicos: FilesUpload
}




export class Direcciones extends React.Component<RouteComponentProps<{}>, DireccionesDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, dtoDataL: new DireccionesData(), dtoDataO: new DireccionesData(),
            paisListL: [], provinciaListL: [], cantonListL: [], parroquiaListL: [],
            paisListO: [], provinciaListO: [], cantonListO: [], parroquiaListO: [],
            planillaServiciosBasicos: { uploadFile: null, nameFile: "", src: "" },
            error: null, errorOccurred: false, idNacionalidad: 1, lugarResidenciaVisible: false,
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarProvincias = this.cargarProvincias.bind(this);
        this.cargarCantones = this.cargarCantones.bind(this);
        this.cargarParroquias = this.cargarParroquias.bind(this);
        this.cargarDirecciones = this.cargarDirecciones.bind(this);
        this.onMapClicked = this.onMapClicked.bind(this);
        this.onAceptClicked = this.onAceptClicked.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.onClickIgualDomicilio = this.onClickIgualDomicilio.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleValoresSelectCargados = this.handleValoresSelectCargados.bind(this);

        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarDirecciones();
                }
            }
        );
    }


    handleFileUploadChange(nombreArchivo: string, uploadFile: File) {

        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo: FilesUpload = { nameFile: nombreArchivo, uploadFile, src };

        this.setState({
            planillaServiciosBasicos: fileInfo,
        });

    }


    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {
                        var paisList: Array<{ value: string; label: string }> = [];

                        if (result.entTabla) {
                            paisList = Array.isArray(result.entTabla)
                                ? result.entTabla.map(d => ({
                                    value: d.idpais,
                                    label: d.nombre
                                }))
                                : []
                        }



                        this.setState({
                            paisListL: paisList,
                            paisListO: paisList,
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los países.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisListL: [],
                        paisListO: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        fetch(API_URL + "DatosGenerales/PersonaId/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {

                        this.setState({
                            idNacionalidad: result.entTabla[0].idnacionalidad,
                        });

                    } else if (result.strEstado === "N") {

                        alertService.error("Ocurrió un error al obtener los datos de la persona.")
                    }
                    else {
                        alertService.error("Ocurrió un error: " + result)
                    }
                },
                (error) => {
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleValoresSelectCargados(value: string | number, opcionesUsadas: Array<SelectCombo>) {
        var parseValue: string = value.toString();
        return opcionesUsadas.find((opciones, indiopciones) => {
            return opciones.value === parseValue
        })
    }

    cargarDirecciones() {
        //API PARA OBTENER DIRECCIONES
        fetch(API_URL + "DatosDireccion/LugarDomicilioByIdPersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {
                        var dLto = new DireccionesData();
                        var dOto = new DireccionesData();
                        for (var i = 0; i < result.entTabla.length; i++) {
                            if (result.entTabla[i].tipo === "L") {
                                dLto = result.entTabla[i];

                                if (dLto.localizacion) {
                                    dLto["localizacion"] = dLto.localizacion.trim();
                                }
                                if (!dLto.coordenadas) {
                                    navigator.geolocation.getCurrentPosition(pos => {
                                        const coords = pos.coords;
                                        latL = coords.latitude
                                        lngL = coords.longitude
                                    });
                                }
                                else {
                                    latL = parseFloat(dLto.coordenadas.split(",")[0]);
                                    lngL = parseFloat(dLto.coordenadas.split(",")[1]);
                                }



                            }
                            else if (result.entTabla[i].tipo === "O") {
                                dOto = result.entTabla[i];

                                if (dOto.localizacion) {
                                    dOto["localizacion"] = dOto.localizacion.trim();
                                }
                                if (!dOto.coordenadas) {
                                    navigator.geolocation.getCurrentPosition(pos => {
                                        const coords = pos.coords;
                                        latO = coords.latitude
                                        lngO = coords.longitude
                                    });
                                }
                                else {
                                    latO = parseFloat(dOto.coordenadas.split(",")[0]);
                                    lngO = parseFloat(dOto.coordenadas.split(",")[1]);
                                }
                            }
                        }

                        if (!dLto.coordenadas) {
                            navigator.geolocation.getCurrentPosition(pos => {
                                const coords = pos.coords;
                                latL = coords.latitude
                                lngL = coords.longitude
                            });
                        }

                        if (!dOto.coordenadas) {
                            navigator.geolocation.getCurrentPosition(pos => {
                                const coords = pos.coords;
                                latO = coords.latitude
                                lngO = coords.longitude
                            });
                        }

                        dLto.bloquemanzana = dLto.bloquemanzana ? dLto.bloquemanzana.trim() : dLto.bloquemanzana;
                        dOto.bloquemanzana = dOto.bloquemanzana ? dOto.bloquemanzana.trim() : dOto.bloquemanzana;
                        var lugarResidenciaVisible = false;
                        if (dOto.idlugardomicilio !== 0) {
                            lugarResidenciaVisible = true
                        }



                        this.setState({
                            dtoDataL: dLto,
                            dtoDataO: dOto,
                            loading: false,
                            lugarResidenciaVisible: lugarResidenciaVisible
                        });

                        if (dLto["idpais"]) {
                            this.cargarProvincias(dLto["idpais"], "idpais", "L", false)
                            this.cargarCantones(dLto["idprovincia"], "idprovincia", "L", false)
                            this.cargarParroquias(dLto["idcanton"], "idcanton", "L", false)
                        }

                        if (dOto["idpais"]) {
                            this.cargarProvincias(dOto["idpais"], "idpais", "O", false)
                            this.cargarCantones(dOto["idprovincia"], "idprovincia", "O", false)
                            this.cargarParroquias(dOto["idcanton"], "idcanton", "O", false)
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener el lugar de domicilio de la persona.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoDataL: new DireccionesData(),
                        dtoDataO: new DireccionesData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarProvincias(idPais, name = "idpais", tipo, change = true) {
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL[name] = idPais;

            var cantonListL = this.state.cantonListL;
            if (change) {
                dtoL["idprovincia"] = 0;
                dtoL["idcanton"] = 0;
                dtoL["idparroquia"] = 0;
                cantonListL = []
            }

            this.setState({ dtoDataL: dtoL, cantonListL: cantonListL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO[name] = idPais;
            var cantonListO = this.state.cantonListO;
            if (change) {
                dtoO["idprovincia"] = 0;
                dtoO["idcanton"] = 0;
                dtoO["idparroquia"] = 0;
                cantonListO = []
            }

            this.setState({ dtoDataO: dtoO, cantonListO: cantonListO });
        }

        fetch(API_URL + "DatosGenerales/ProvinciaIdPais/" + idPais)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {
                        if (tipo === "L") {
                            var provinciaListL: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                provinciaListL = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idprovincia,
                                        label: d.nombre
                                    }))
                                    : []
                            }
                            this.setState({
                                provinciaListL
                            });
                        }
                        else if (tipo === "O") {
                            var provinciaListO: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                provinciaListO = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idprovincia,
                                        label: d.nombre
                                    }))
                                    : []
                            }
                            this.setState({
                                provinciaListO
                            });

                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las provincias.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        provinciaListL: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarCantones(idProvincia, name = "idprovincia", tipo, change = true) {
        if (idProvincia === null || idProvincia === undefined) {
            return
        }
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL[name] = idProvincia;

            var parroquiaListL = this.state.parroquiaListL;
            if (change) {
                dtoL["idcanton"] = 0;
                dtoL["idparroquia"] = 0;
                parroquiaListL = []
            }

            this.setState({ dtoDataL: dtoL, parroquiaListL: parroquiaListL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO[name] = idProvincia;
            var parroquiaListO = this.state.parroquiaListO;
            if (change) {
                dtoO["idcanton"] = 0;
                dtoO["idparroquia"] = 0;
                parroquiaListO = []
            }

            this.setState({ dtoDataO: dtoO, parroquiaListO: parroquiaListO });
        }

        fetch(API_URL + "DatosGenerales/CantonIdProvincia/" + idProvincia)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {
                        if (tipo === "L") {
                            var valueLabelCanton: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                valueLabelCanton = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idcanton,
                                        label: d.nombre
                                    }))
                                    : []
                            }

                            this.setState({
                                cantonListL: valueLabelCanton,
                                loading: false
                            });
                        }
                        else if (tipo === "O") {
                            var cantonListO: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                cantonListO = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idcanton,
                                        label: d.nombre
                                    }))
                                    : []
                            }

                            this.setState({
                                cantonListO,
                                loading: false
                            });




                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener los cantones.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        cantonListL: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarParroquias(idCanton, name = "idcanton", tipo, change = true) {
        if (idCanton === null || idCanton === null) {
            return
        }
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL[name] = idCanton;

            if (change) {
                dtoL["idparroquia"] = 0;
            }

            this.setState({ dtoDataL: dtoL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO[name] = idCanton;

            if (change) {
                dtoO["idparroquia"] = 0;
            }

            this.setState({ dtoDataO: dtoO });
        }

        fetch(API_URL + "DatosGenerales/ParroquiaIdCanton/" + idCanton)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result && result.strEstado === "S") {
                        if (tipo === "L") {
                            var parroquiaListL: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                parroquiaListL = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idparroquia,
                                        label: d.nombre
                                    }))
                                    : []
                            }
                            this.setState({
                                parroquiaListL,
                                loading: false
                            });



                        }
                        else if (tipo === "O") {
                            var parroquiaListO: Array<{ value: string; label: string }> = [];

                            if (result.entTabla) {
                                parroquiaListO = Array.isArray(result.entTabla)
                                    ? result.entTabla.map(d => ({
                                        value: d.idparroquia,
                                        label: d.nombre
                                    }))
                                    : []
                            }
                            this.setState({
                                parroquiaListO,
                                loading: false
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las parroquias.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        cantonListL: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event, tipo) {
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL[event.target.name] = event.target.value;
            this.setState({ dtoDataL: dtoL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO[event.target.name] = event.target.value;
            this.setState({ dtoDataO: dtoO });
        }
    }

    handleSelectChange(value, name, tipo) {
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL[name] = value;
            this.setState({ dtoDataL: dtoL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO[name] = value;
            this.setState({ dtoDataO: dtoO });
        }

    }

    onMapClicked(mapProps, tipo) {

        if (tipo === "L") {
            latL = mapProps['lat'];
            lngL = mapProps['lng'];
        }
        else if (tipo === "O") {
            latO = mapProps['lat'];
            lngO = mapProps['lng'];
        }

        //console.log(latO)
        //console.log(lngO)

        this.setState((state, props) => ({
            loading: false
        }));

    }

    onAceptClicked(coordenadas, tipo) {
        if (tipo === "L") {
            var dtoL = this.state.dtoDataL;
            dtoL["coordenadas"] = coordenadas;
            this.setState({ dtoDataL: dtoL });
        }
        else if (tipo === "O") {
            var dtoO = this.state.dtoDataO;
            dtoO["coordenadas"] = coordenadas;
            this.setState({ dtoDataO: dtoO });
        }

    }

    onClickLimpiar() {
        this.setState({
            dtoDataL: new DireccionesData()
        });
    }

    onClickIgualDomicilio() {
        let dtoO = this.state.dtoDataL;
        this.cargarProvincias(dtoO["idpais"], "idpais", "O", false)
        this.cargarCantones(dtoO["idprovincia"], "idprovincia", "O", false)
        this.cargarParroquias(dtoO["idcanton"], "idcanton", "O", false)
        this.setState({
            dtoDataO: dtoO
        });
    }

    onClickLugarResidencia() {
        this.setState({
            lugarResidenciaVisible: !this.state.lugarResidenciaVisible
        });
    }

    private async handleSave(event) {

        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];        
        event.preventDefault();
        const forma = new FormData(event.target);
        var dtoL = this.state.dtoDataL;
        var dtoO = this.state.dtoDataO;
        const informacionPlanilla: FilesUpload = this.state.planillaServiciosBasicos;
        var formFilesData = new FormData();

        var flag = 0
        let formIsValid = true;
        var numCamposVacios = 0

        forma.forEach((value, clave) => {
            if (clave === "idpais") {
                flag += 1;
            }

            if (!value) {
                if (flag === 2) {
                    if (dtoO.idpais === 1) {
                        formIsValid = false;
                    }
                    else if (clave !== "idparroquia") {
                        formIsValid = false;
                    }
                }
                else {
                    if (!this.state.lugarResidenciaVisible) {
                        {
                            formIsValid = false;
                        }
                    }
                    else {
                        numCamposVacios += 1;
                    }
                }
            }

            if (typeof dtoL[clave] === 'number') {

                if (flag === 2) {
                    dtoO[clave] = Number(value);
                }
                else {
                    dtoL[clave] = Number(value);
                }
            }
            else if (typeof dtoL[clave] === 'boolean') {

                if (flag === 2) {
                    dtoO[clave] = Boolean(value);
                }
                else {
                    dtoL[clave] = Boolean(value);
                }
            }
            else {

                if (flag === 2) {
                    dtoO[clave] = value;
                }
                else {
                    dtoL[clave] = value;
                }
            }

        });

        dtoL["tipo"] = "L";
        dtoO["tipo"] = "O";

        dtoL["Direcciontiponro"] = dtoL["direcciontiponro"];
        dtoO["Direcciontiponro"] = dtoO["direcciontiponro"];

        delete dtoL['direcciontiponro']
        delete dtoO['direcciontiponro']


        dtoL["coordenadas"] = latL + ", " + lngL;
        dtoO["coordenadas"] = latO + ", " + lngO;

        dtoL.idpersona = this.state.currentUser.idpersona;
        dtoO.idpersona = this.state.currentUser.idpersona;

        dtoL.Namearchivocroquis = "*****";
        dtoO.Namearchivocroquis = "*****";

        var data = JSON.stringify({
            "tlugardomicilio": dtoL
        });

        if (this.state.lugarResidenciaVisible) {
            //if (numCamposVacios === 12) {

            //}
            if (numCamposVacios === 0) {
                data = JSON.stringify({
                    "tlugardomicilio": dtoL, "tlugardomicilioorigen": dtoO
                });
            }
            else {
                //alertService.error("Error: En caso de no tener dirección domiciliaria en Ecuador, dejar los campos vacios.");
                //return;
                data = JSON.stringify({
                    "tlugardomicilioorigen": dtoO
                });
            }

        }

        if (!this.state.lugarResidenciaVisible && (informacionPlanilla.uploadFile === null || informacionPlanilla.src === "") && (dtoL.namearchivoplanilla === null || dtoL.namearchivoplanilla === "")) {
            formIsValid = false;
        }

        const archivoPlanilla: any = informacionPlanilla.uploadFile

        if (archivoPlanilla !== null) {
            formFilesData.append("ArchivoPlanillaServiciosBasicos", archivoPlanilla, informacionPlanilla.nameFile);

        }

        const actualizaPlanilla: boolean = archivoPlanilla != null

        formFilesData.append("tlugardomicilio", JSON.stringify(dtoL));
        formFilesData.append("tlugardomicilioorigen", JSON.stringify(dtoO));
        formFilesData.append("actualizaPlantilla", JSON.stringify(actualizaPlanilla));


        if (formIsValid) {
            try {
                const datosUsuario: UserData = authenticationService.currentUserValue;
                const respuesta = await axios.post(API_URL + "FormularioController/PostDatosDireccion", formFilesData, {
                    headers: {
                        ...authHeaderWithUserData(datosUsuario),
                        'Content-Type': 'multipart/form-data'
                    }
                })

                const responseJson = respuesta.data;
                if (responseJson["strEstado"] === "N") {
                    alertService.error(responseJson["strMensaje"])
                }
                else if (responseJson["strEstado"] === "S") {
                    alertService.success("La sección de Direcciones ha sido actualizada correctamente.")
                    authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                    this.cargarDirecciones();
                }
                else {
                    alertService.error("Ocurrió un error: " + responseJson)
                }

                let myDiv = document.getElementById('root')!;
                myDiv.scrollTo(0, 0);
            } catch (error) {
                alertService.error("Ocurrió un error: " + error)
            }
        }
        else {
            alertService.error(mensajeCamposIncompletos());
        }

        //     fetch(API_URL + "FormularioController/PostDatosDireccion", {

        //         method: 'POST',
        //         headers: { 
        //             'Content-Type': 'multipart/form-data',

        //         },

        //         body: formFilesData
        //         // body: data,

        //     })
        //         .then(response => response.json())
        //         .then(
        //             (responseJson) => {
        //                 if (responseJson["strEstado"] === "N") {
        //                     alertService.error(responseJson["strMensaje"])
        //                 }
        //                 else if (responseJson["strEstado"] === "S") {
        //                     alertService.success("La sección de Direcciones ha sido actualizada correctamente.")
        //                     authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
        //                     this.cargarDirecciones();
        //                 }
        //                 else {
        //                     alertService.error("Ocurrió un error: " + responseJson)
        //                 }

        //                 let myDiv = document.getElementById('root')!;
        //                 myDiv.scrollTo(0, 0);

        //             },
        //             (error) => {

        //                 alertService.error("Ocurrió un error: " + error)
        //             })
        // }




    }


    public render() {

        let contents = this.state.loading

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.paisListL, this.state.provinciaListL, this.state.cantonListL, this.state.parroquiaListL,
                this.state.paisListO, this.state.provinciaListO, this.state.cantonListO, this.state.parroquiaListO);

        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(paisListL: Array<any>, provinciaListL: Array<any>, cantonListL: Array<any>, parroquiaListL: Array<any>,
        paisListO: Array<any>, provinciaListO: Array<any>, cantonListO: Array<any>, parroquiaListO: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <form onSubmit={this.handleSave} id="formDireccion">
                            <Card className="principal">
                                <CardHeader>
                                    <h5 className="title">DIRECCIÓN DOMICILIARIA EN ECUADOR</h5>
                                </CardHeader>
                                <Row form>
                                    <Col md={12} className="pr-3">
                                        <FormGroup>
                                            <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>
                                                Agregar nueva dirección
                                            </Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <CardBody className="main-content">
                                    <div>
                                        <Row form>
                                            <Input hidden type="text" value={this.state.dtoDataL.idpais} name="idpais" required />
                                            {
                                                //<Col md={3} sm={12} xs={12}>
                                                //    <FormGroup>
                                                //        <Label for="idpais">País*</Label>
                                                //        <InputGroup>
                                                //            <Input hidden type="text" value={this.state.dtoDataL.idpais} name="idpais" required />
                                                //            <Input readOnly type="text" value="ECUADOR" required />
                                                //            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                //                <Icon kind="pais" fill='#FFFFFF' width={27} height={27} />
                                                //            </InputGroupAddon>
                                                //        </InputGroup>
                                                //        {
                                                //            //<SelectItem
                                                //            //    options={paisListL}
                                                //            //    value={this.state.dtoDataL.idpais}
                                                //            //    onChange={this.cargarProvincias}
                                                //            //    placeholder="País"
                                                //            //    name="idpais"
                                                //            //    id="pais"
                                                //            //    icon="pais"
                                                //            //    tipo="L"
                                                //            //    disabled={true}
                                                //            ///>
                                                //        }
                                                //    </FormGroup>
                                                //</Col>
                                            }

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nombres">Provincia*</Label>
                                                    <SelectItem
                                                        options={provinciaListL}
                                                        value={this.state.dtoDataL.idprovincia}
                                                        onChange={this.cargarCantones}
                                                        placeholder="Provincia"
                                                        name="idprovincia"
                                                        id="provincia"
                                                        icon="ubicacion"
                                                        tipo="L"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="apellidos">Ciudad*</Label>
                                                    <SelectItem
                                                        options={cantonListL}
                                                        value={this.state.dtoDataL.idcanton}
                                                        onChange={this.cargarParroquias}
                                                        placeholder="Ciudad"
                                                        name="idcanton"
                                                        id="canton"
                                                        icon="ubicacion"
                                                        tipo="L"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {/*<Col md={3}>*/}
                                            {/*    <FormGroup>*/}
                                            {/*        <Label for="localizacion">Localización*</Label>*/}
                                            {/*        <SelectItem*/}
                                            {/*            options={SELECT_LOCALIZACIONES}*/}
                                            {/*            value={this.state.dtoDataL.localizacion}*/}
                                            {/*            onChange={this.handleSelectChange}*/}
                                            {/*            placeholder="Localizacion"*/}
                                            {/*            name="localizacion"*/}
                                            {/*            id="localizacion"*/}
                                            {/*            icon="ubicacion"*/}
                                            {/*            tipo="L"*/}
                                            {/*        />*/}
                                            {/*    </FormGroup>*/}
                                            {/*</Col>*/}
                                            {/*<Col md={3}>*/}
                                            {/*    <FormGroup>*/}
                                            {/*        <Label for="fechanacimiento">Parroquia*</Label>*/}
                                            {/*        <SelectItem*/}
                                            {/*            options={parroquiaListL}*/}
                                            {/*            value={this.state.dtoDataL.idparroquia}*/}
                                            {/*            onChange={this.handleSelectChange}*/}
                                            {/*            placeholder="Parroquia"*/}
                                            {/*            name="idparroquia"*/}
                                            {/*            id="parroquia"*/}
                                            {/*            icon="ubicacion"*/}
                                            {/*            tipo="L"*/}
                                            {/*        />*/}
                                            {/*    </FormGroup>*/}
                                            {/*</Col>*/}
                                        </Row>


                                        <Row form>
                                            <Label for="cdlaobarrio" md={2}>Barrio/Sector/Ciud./Urb.*</Label>
                                            <Col md={4}>
                                                <InputGroup>
                                                    <Input type="text" maxLength="150" value={this.state.dtoDataL.cdlaobarrio} tipo="L" name="cdlaobarrio" placeholder="Barrio/Sector/Ciud./Urb." onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />
                                                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                        <Icon kind="barrio_sector" fill='#FFFFFF' width={27} height={27} />
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </Col>
                                            <Label for="direccion" md={2}>Calle principal*</Label>
                                            <Col md={4}>
                                                <InputGroup>
                                                    <Input type="text" maxLength="200" value={this.state.dtoDataL.direccion} tipo="L" name="direccion" placeholder="Calle principal" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />
                                                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                        <Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} />
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </Col>
                                        </Row>

                                        <Row form>

                                            <Label for="direccion" md={2}>Calle secundaria*</Label>
                                            <Col md={4}>
                                                <InputGroup>
                                                    <Input type="text" maxLength="200" value={this.state.dtoDataL.direccionalterna} tipo="L" name="direccionalterna" placeholder="Calle secundaria" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />
                                                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                        <Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} />
                                                    </InputGroupAddon>
                                                </InputGroup>
                                            </Col>
                                            {/*<Label for="bloquemanzana" md={2}>Mz./Bloque*</Label>*/}
                                            {/*<Col md={4}>*/}
                                            {/*    <InputGroup>*/}
                                            {/*        <Input type="text" maxLength="15" tipo="L"  value={this.state.dtoDataL.bloquemanzana ? this.state.dtoDataL.bloquemanzana.trim() : this.state.dtoDataL.bloquemanzana} name="bloquemanzana" placeholder="Mz./Bloque" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />*/}
                                            {/*        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                            {/*            <Icon kind="manzana_bloque" fill='#FFFFFF' width={27} height={27} />*/}
                                            {/*        </InputGroupAddon>*/}
                                            {/*    </InputGroup>*/}
                                            {/*</Col>*/}
                                        </Row>

                                        {/*<Row form>*/}
                                        {/*    <Label for="direcciontiponro" md={2}>Nº de domicilio (Edificio/Villa/solar)*</Label>*/}
                                        {/*    <Col md={4}>*/}
                                        {/*        <InputGroup>*/}
                                        {/*            <Input type="text" maxLength="10" tipo="L" value={this.state.dtoDataL.direcciontiponro} name="direcciontiponro" placeholder="Nº de domicilio (Edificio/Villa/Solar)" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />*/}
                                        {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                        {/*                <Icon kind="numero_n" fill='#FFFFFF' width={27} height={27} />*/}
                                        {/*            </InputGroupAddon>*/}
                                        {/*        </InputGroup>*/}
                                        {/*    </Col>*/}
                                        {/*    <Label for="cdlaobarrio" md={2}>Referencia*</Label>*/}
                                        {/*    <Col md={4}>*/}
                                        {/*        <InputGroup>*/}
                                        {/*            <Input type="text" maxLength="200" tipo="L" value={this.state.dtoDataL.referencia} name="referencia" placeholder="Referencia" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />*/}
                                        {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                        {/*                <Icon kind="referencia" fill='#FFFFFF' width={27} height={27} />*/}
                                        {/*            </InputGroupAddon>*/}
                                        {/*        </InputGroup>*/}
                                        {/*    </Col>*/}

                                        {/*</Row>*/}



                                        <Row form>
                                            <Label for="coordenadas" md={2}>Ubicación en el mapa</Label>
                                            <Col md={4}>
                                                <ModalMap
                                                    onClick={(e) => this.onMapClicked(e, "L")}
                                                    lat={new Number(latL)}
                                                    lng={new Number(lngL)}
                                                    value={this.state.dtoDataL.coordenadas}
                                                    onAcept={this.onAceptClicked}
                                                    onChangeInput={this.handleChange}
                                                    tipo="L"
                                                />
                                            </Col>
                                            {/*<Label for="codigopostal" md={2}>Código postal*</Label>*/}
                                            {/*<Col md={4}>*/}
                                            {/*    <InputGroup>*/}
                                            {/*        <Input type="text" value={this.state.dtoDataL.codigopostal} tipo="L" name="codigopostal" placeholder="Código postal" onChange={(event) => this.handleChange(event, "L")} required={!this.state.lugarResidenciaVisible} />*/}
                                            {/*        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                            {/*            <Icon kind="codigo_postal" fill='#FFFFFF' width={27} height={27} />*/}
                                            {/*        </InputGroupAddon>*/}
                                            {/*    </InputGroup>*/}
                                            {/*</Col>*/}
                                        </Row>

                                        <Row form>
                                            {/*<Label for="planilla" md={2}>Planilla de servicios básicos*</Label>*/}
                                            {/*<Col md={4}>*/}
                                            {/*    <div className="containerEvidenciaDG">*/}
                                            {/*        <InputFileUpload*/}
                                            {/*            className="firstevidencia"*/}
                                            {/*            icon="upload"*/}
                                            {/*            onChange={this.handleFileUploadChange}*/}
                                            {/*            name="PL"*/}
                                            {/*            placeholder={this.state.dtoDataL.namearchivoplanilla ? "Actualizar Planilla" : "Subir Planilla "}*/}
                                            {/*            required={true}*/}
                                            {/*            tipo="L"*/}
                                            {/*        />*/}
                                            {/*        <InputFileDownload tipo="planilla"*/}
                                            {/*            id="downloadRef"*/}
                                            {/*            refarchivo={this.state.dtoDataL.namearchivoplanilla}*/}
                                            {/*            name={"PLANILLA SERVICIOS BASICOS.pdf"}*/}
                                            {/*            url={API_URL + "Files/GetArchivoVistaPrevia/refArchivo/" + this.state.dtoDataL.namearchivoplanilla}*/}
                                            {/*            className="secondevidencia pr-0"*/}
                                            {/*        />*/}
                                            {/*    </div>*/}

                                            {/*</Col>*/}



                                        </Row>

                                        <FormGroup row>
                                            <Label for="codigopostal" md={3}>(*) Campos obligatorios</Label>
                                        </FormGroup>

                                    </div>
                                </CardBody>

                            </Card>
                            {
                                this.state.dtoDataO.idlugardomicilio === 0 ?
                                    <p>Si su lugar de residencia es diferente a su domicilio en Ecuador
                                        <Button color="primary" type="button" className="btn btn-default ml-1" style={{ float: "none" }} onClick={() => this.onClickLugarResidencia()}>
                                            presione aquí
                                        </Button>
                                    </p>
                                    :
                                    null
                            }

                            {
                                this.state.idNacionalidad !== 1 && this.state.idNacionalidad !== null || this.state.lugarResidenciaVisible ?
                                    <Card className="principal">
                                        <CardHeader>
                                            <h5 className="title">LUGAR DE RESIDENCIA</h5>
                                        </CardHeader>
                                        {
                                            //<Row form>
                                            //    <Col md={12} className="pr-3">
                                            //        <FormGroup>
                                            //            <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickIgualDomicilio()}>
                                            //                Igual a la de domicilio
                                            //    </Button>
                                            //        </FormGroup>
                                            //    </Col>
                                            //</Row>
                                        }

                                        <CardBody className="main-content">
                                            <div>
                                                <Row form>
                                                    <Col md={3} sm={12} xs={12}>
                                                        <FormGroup>
                                                            <Label for="idpais">País*</Label>
                                                            <SelectItem
                                                                options={paisListO}
                                                                value={this.state.dtoDataO.idpais}
                                                                onChange={this.cargarProvincias}
                                                                placeholder="País"
                                                                name="idpais"
                                                                id="pais"
                                                                icon="pais"
                                                                tipo="O"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="nombres">Provincia*</Label>
                                                            <SelectItem
                                                                options={provinciaListO}
                                                                value={this.state.dtoDataO.idprovincia}
                                                                onChange={this.cargarCantones}
                                                                placeholder="Provincia"
                                                                name="idprovincia"
                                                                id="provincia"
                                                                icon="ubicacion"
                                                                tipo="O"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    {/*<Col md={3}>*/}
                                                    {/*    <FormGroup>*/}
                                                    {/*        <Label for="apellidos">Ciudad*</Label>*/}
                                                    {/*        <SelectItem*/}
                                                    {/*            options={cantonListO}*/}
                                                    {/*            value={this.state.dtoDataO.idcanton}*/}
                                                    {/*            onChange={this.cargarParroquias}*/}
                                                    {/*            placeholder="Ciudad"*/}
                                                    {/*            name="idcanton"*/}
                                                    {/*            id="canton"*/}
                                                    {/*            icon="ubicacion"*/}
                                                    {/*            tipo="O"*/}
                                                    {/*        />*/}
                                                    {/*    </FormGroup>*/}
                                                    {/*</Col>*/}
                                                    {/*<Col md={3}>*/}
                                                    {/*    <FormGroup>*/}
                                                    {/*        <Label for="fechanacimiento">Parroquia</Label>*/}
                                                    {/*        <SelectItem*/}
                                                    {/*            options={parroquiaListO}*/}
                                                    {/*            value={this.state.dtoDataO.idparroquia}*/}
                                                    {/*            onChange={this.handleSelectChange}*/}
                                                    {/*            placeholder="Parroquia"*/}
                                                    {/*            name="idparroquia"*/}
                                                    {/*            id="parroquia"*/}
                                                    {/*            icon="ubicacion"*/}
                                                    {/*            tipo="O"*/}
                                                    {/*        />*/}
                                                    {/*    </FormGroup>*/}
                                                    {/*</Col>*/}
                                                </Row>
                                                <Row form>
                                                    {/*<Col md={3} sm={12}>*/}
                                                    {/*    <FormGroup>*/}
                                                    {/*        <Label for="localizacion">Localización*</Label>*/}
                                                    {/*        <SelectItem*/}
                                                    {/*            options={SELECT_LOCALIZACIONES}*/}
                                                    {/*            value={this.state.dtoDataO.localizacion}*/}
                                                    {/*            onChange={this.handleSelectChange}*/}
                                                    {/*            placeholder="Localizacion"*/}
                                                    {/*            name="localizacion"*/}
                                                    {/*            id="localizacion"*/}
                                                    {/*            icon="ubicacion"*/}
                                                    {/*            tipo="O"*/}
                                                    {/*        />*/}
                                                    {/*    </FormGroup>*/}
                                                    {/*</Col>*/}
                                                </Row>
                                                <Row form>

                                                    <Label for="direccion" md={2}>Calle principal*</Label>
                                                    <Col md={4}>
                                                        <InputGroup>
                                                            <Input type="text" maxLength="200" value={this.state.dtoDataO.direccion} name="direccion" placeholder="Calle principal" onChange={(event) => this.handleChange(event, "O")} required />
                                                            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                <Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </Col>
                                                    <Label for="direccion" md={2}>Calle secundaria*</Label>
                                                    <Col md={4}>
                                                        <InputGroup>
                                                            <Input type="text" maxLength="200" value={this.state.dtoDataO.direccionalterna} placeholder="Calle secundaria" name="direccionalterna" onChange={(event) => this.handleChange(event, "O")} required />
                                                            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                <Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} />
                                                            </InputGroupAddon>
                                                        </InputGroup>
                                                    </Col>
                                                </Row>

                                                {/*<Row form>*/}
                                                {/*    <Label for="direcciontiponro" md={2}>Nº de domicilio*</Label>*/}
                                                {/*    <Col md={4}>*/}
                                                {/*        <InputGroup>*/}
                                                {/*            <Input type="text" maxLength="10" value={this.state.dtoDataO.direcciontiponro} placeholder="Nº de domicilio" name="direcciontiponro" onChange={(event) => this.handleChange(event, "O")} required />*/}
                                                {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                                {/*                <Icon kind="numero_n" fill='#FFFFFF' width={27} height={27} />*/}
                                                {/*            </InputGroupAddon>*/}
                                                {/*        </InputGroup>*/}
                                                {/*    </Col>*/}
                                                {/*    <Label for="bloquemanzana" md={2}>Mz. Bloque*</Label>*/}
                                                {/*    <Col md={4}>*/}
                                                {/*        <InputGroup>*/}
                                                {/*            <Input type="text" maxLength="15" value={this.state.dtoDataO.bloquemanzana} name="bloquemanzana" placeholder="Mz. Bloque" onChange={(event) => this.handleChange(event, "O")} required />*/}
                                                {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                                {/*                <Icon kind="manzana_bloque" fill='#FFFFFF' width={27} height={27} />*/}
                                                {/*            </InputGroupAddon>*/}
                                                {/*        </InputGroup>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}

                                                {/*<Row form>*/}
                                                {/*    <Label for="cdlaobarrio" md={2}>Barrio ó Sector*</Label>*/}
                                                {/*    <Col md={4}>*/}
                                                {/*        <InputGroup>*/}
                                                {/*            <Input type="text" maxLength="150" value={this.state.dtoDataO.cdlaobarrio} name="cdlaobarrio" placeholder="Barrio ó Sector" onChange={(event) => this.handleChange(event, "O")} required />*/}
                                                {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                                {/*                <Icon kind="barrio_sector" fill='#FFFFFF' width={27} height={27} />*/}
                                                {/*            </InputGroupAddon>*/}
                                                {/*        </InputGroup>*/}
                                                {/*    </Col>*/}
                                                {/*    <Label for="cdlaobarrio" md={2}>Referencia*</Label>*/}
                                                {/*    <Col md={4}>*/}
                                                {/*        <InputGroup>*/}
                                                {/*            <Input type="text" maxLength="200" value={this.state.dtoDataO.referencia} name="referencia" placeholder="Referencia" onChange={(event) => this.handleChange(event, "O")} required />*/}
                                                {/*            <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>*/}
                                                {/*                <Icon kind="referencia" fill='#FFFFFF' width={27} height={27} />*/}
                                                {/*            </InputGroupAddon>*/}
                                                {/*        </InputGroup>*/}
                                                {/*    </Col>*/}
                                                {/*</Row>*/}

                                                <Row form>
                                                    <Label for="coordenadas" md={2}>Ubicación en el mapa</Label>
                                                    <Col md={4}>
                                                        <ModalMap
                                                            onClick={(e) => this.onMapClicked(e, "O")}
                                                            lat={new Number(latO)}
                                                            lng={new Number(lngO)}
                                                            value={this.state.dtoDataO.coordenadas}
                                                            onAcept={this.onAceptClicked}
                                                            tipo="O"
                                                        />
                                                    </Col>
                                                </Row>


                                            </div>
                                        </CardBody>

                                    </Card>
                                    :
                                    null
                            }
                            <div className="form-group">
                                <button type="submit" className="btn btn-default">Guardar</button>
                            </div >

                        </form >
                    </Col>
                </Row>

            </>
        );
    }
}
export default Direcciones;